module.exports = __webpack_public_path__ + "static/img/zijian.d6dcd67d.jpg";